export default {"src":"/_next/static/media/GCM-logo.a155c392.svg","height":74,"width":300};